$(document).ready(function () {

  $(".template-abner .product-section__variant-thumbnail").each(function () {
    var filter_alt = $(this).data("filter");
    var rx_link = $(this).data("prescription-btn");

    var isStock = $(this).data("is-stock");
    if ($(this).hasClass("is-active")) {
      $(".product-section__media-single." + filter_alt).show();

      rx_link ? $(".link-to-rx").addClass("link-to-rx_visible") : $(".link-to-rx").removeClass("link-to-rx_visible");
     

      isStock ? $(".link-to-rx_out-of-stock").removeClass("link-to-rx_visible") : !rx_link ? $(".link-to-rx_out-of-stock").removeClass("link-to-rx_visible") : $(".link-to-rx_out-of-stock").addClass("link-to-rx_visible");
      $(".link-to-rx").attr("href", rx_link);
    }
  });
  $(".template-abner .product-section__variant-thumbnail").on(
    "click",
    function () {
      var filter_alt = $(this).data("filter");
      var filter_id = $(this).data("variant-id");
      var rx_link = $(this).data("prescription-btn");
      var isStock = $(this).data("is-stock");
      $(".product-section__variant-thumbnail").removeClass("is-active");
      $(this).addClass("is-active");
      $(".product-section__media-single").hide();
      $(".product-section__media-single." + filter_alt).show();
      $(".product_suspendisse").hide();
      $(".product_suspendisse_" + filter_id).show();

      rx_link ? $(".link-to-rx").addClass("link-to-rx_visible") : $(".link-to-rx").removeClass("link-to-rx_visible");
     

      isStock ? $(".link-to-rx_out-of-stock").removeClass("link-to-rx_visible") : !rx_link ? $(".link-to-rx_out-of-stock").removeClass("link-to-rx_visible") : $(".link-to-rx_out-of-stock").addClass("link-to-rx_visible");
      $(".link-to-rx").attr("href", rx_link);
      if ($(window).width() < 768) {
        document
          .querySelector(".product-section__desktop-media")
          .scrollTo(0, 0);
      }
    }
  );
  if ($(window).width() < 767) {
    $(window).on("mouseup", function (e) {
      var target = $(e.target);
      $(".tippy-step").next().hide();
      if (target.closest(".tippy-step").length > 0) {
        if (target.closest(".tippy-step").next().hasClass("show_")) {
            target.closest(".tippy-step").next().hide();
            $(".tippy-step").next().removeClass("show_")
        }else{
            target.closest(".tippy-step").next().show();
            $(".tippy-step").next().removeClass("show_")
            target.closest(".tippy-step").next().addClass("show_")
        }
      } else {
        $(".tippy-step").next().removeClass("show_")
      }
    });
  }
 
});
